export default __webpack_public_path__ + "static/media/material4.77d007f6.png";